import z from 'zod'
import { nullSafeOptionalBoolean } from '../shared/schema'

export const schema = z.object({
  roomInspector: nullSafeOptionalBoolean(false),
  userInspector: nullSafeOptionalBoolean(false),
  canViewFeatureFlags: nullSafeOptionalBoolean(false),
  canInvokeEmailTemplateHandler: nullSafeOptionalBoolean(false),
  canEditOutputPrompt: nullSafeOptionalBoolean(false),
  canInstallPrompts: nullSafeOptionalBoolean(false),
  canAlwaysApplyAdminApprovedFreePromotion: nullSafeOptionalBoolean(false),
  canEditClickwraps: nullSafeOptionalBoolean(false),
})

export const empty = Object.freeze(
  schema.parse({
    roomInspector: false,
    userInspector: false,
    canViewFeatureFlags: false,
    canInvokeEmailTemplateHandler: false,
    canEditOutputPrompt: false,
    canInstallPrompts: false,
    canAlwaysApplyAdminApprovedFreePromotion: false,
    canEditClickwraps: false,
  })
)

export type FirestoreSettingsSuperAdmin = z.infer<typeof schema>
